import { Tag, Tooltip, theme } from 'antd'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { formatDateTime } from 'src/utils/dateTime'
import { getWorkspaceDemoDaysLeft } from 'src/utils/workspaceDemo'

type Props = {
  isDemo?: boolean | null
  expiresAt?: string | null
  showRemainingDays?: boolean
  showLabel?: boolean
  compact?: boolean
}

export const WorkspaceDemoBadge = ({
  isDemo,
  expiresAt,
  showRemainingDays = false,
  showLabel = true,
  compact = false
}: Props) => {
  const { token } = theme.useToken()
  const { t } = useTranslation()

  const daysLeft = useMemo(
    () => getWorkspaceDemoDaysLeft(expiresAt),
    [expiresAt]
  )

  if (!isDemo) {
    return null
  }

  const baseLabel = t('workspaceOverview.demo.label')
  const daysLeftLabel =
    daysLeft == null
      ? t('workspaceOverview.demo.noExpiry')
      : daysLeft <= 0
        ? t('workspaceOverview.demo.expired')
        : t('workspaceOverview.demo.daysLeft', {
            count: daysLeft
          })

  const label = showRemainingDays
    ? showLabel
      ? `${baseLabel} - ${daysLeftLabel}`
      : daysLeftLabel
    : baseLabel

  const tooltipTitle = expiresAt
    ? t('workspaceOverview.demo.endsOn', {
        date: formatDateTime(expiresAt)
      })
    : t('workspaceOverview.demo.noExpiryTooltip')

  return (
    <Tooltip title={tooltipTitle}>
      <Tag
        color="gold"
        style={{
          marginInlineEnd: 0,
          fontSize: compact ? 10 : 11,
          lineHeight: compact ? '16px' : '18px',
          paddingInline: compact ? 6 : 7,
          fontWeight: 600,
          borderRadius: token.borderRadiusSM
        }}
      >
        {label}
      </Tag>
    </Tooltip>
  )
}
